import React, { useState, useEffect } from "react";
import SectionCard from "../../Components/SectionCard";
import TextboxSet from "../../Components/TextboxSet";
import ImageUpload from "../../Components/ImageUpload";
import Switch from "react-switch";
import { XMarkIcon } from "@heroicons/react/24/solid";
import LocationSet from "../../Components/LocationSet";
import Button from "../../Components/Button";
import axios from "axios";
import { DELETE_EVENT_API } from "../../Constant/api";
import { useNavigate } from "react-router-dom";
import { EVENT_LIST } from "../../Router/path";
import { useToast } from "../../Components/Toast";
import Modal from "../../Components/Modal";
import { Warning2 } from "iconsax-react";

const EventInformation = ({ eventInfo, setEventInfo }) => {
  const [fileName, setFileName] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const navigate = useNavigate();

  const handleOnChange = (e) => {
    setEventInfo({ ...eventInfo, [e.target.name]: e.target.value });
  };

  const handleDeleteEvent = () => {
    setLoading(true);
    try {
      axios
        .delete(DELETE_EVENT_API, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: localStorage.getItem("event_id"),
          },
        })
        .then((response) => {
          setLoading(false);
          localStorage.removeItem("event_id");
          localStorage.removeItem("dietary");
          localStorage.removeItem("seat");
          navigate(EVENT_LIST);
          toast("Event deleted successfully", "success");
        })
        .catch((error) => {
          setLoading(false);
          toast("Error deleting event", "error");
        });
    } catch (error) {
      setLoading(false);
      toast("Error deleting event", "error");
    }
  };

  const handleImageChange = (value) => {
    // setEventInfo({ ...eventInfo, image: value });
    setEventInfo({ ...eventInfo, image: [...eventInfo.image, value] });
  };

  const handleRemoveImage = (index) => {
    // setEventInfo({ ...eventInfo, image: "" });
    setEventInfo({
      ...eventInfo,
      image: eventInfo.image.filter((_, i) => i !== index),
    });
  };

  const toggleModal = () => {
    setDeleteModal(!deleteModal);
  };

  useEffect(() => {
    const imageName = eventInfo.image ?? [];
    const newFileNames = imageName.map((element) => element.split("/").pop());
    setFileName(newFileNames);
  }, [eventInfo]);

  return (
    <div className="flex flex-col w-full gap-[24px]">
      {/* Event info section */}
      {deleteModal && (
        <Modal
          title="Delete Event"
          confirmation={handleDeleteEvent}
          toggleModal={toggleModal}
          submitLabel="Delete"
        >
          <div className="flex flex-col w-full items-center justify-center gap-[16px] py-[32px]">
            <Warning2 size="64" color="#ff0000" variant="Bold" />
            <p>Are you sure you want to delete this event?</p>
          </div>
        </Modal>
      )}
      <SectionCard title="Event Information">
        <div className="flex flex-col w-full gap-[24px]">
          <div className="flex w-full gap-[24px]">
            <TextboxSet
              type="text"
              name="name"
              value={eventInfo.name}
              label="Event Title"
              onChange={handleOnChange}
              required
            />
            <LocationSet
              onChange={handleOnChange}
              name="venue"
              value={eventInfo.venue}
              placeholder="Venue"
              required
            />
          </div>
          <div className="flex w-full gap-[24px]">
            <TextboxSet
              type="date"
              name="date"
              value={eventInfo.date}
              label="Date"
              onChange={handleOnChange}
              required
            />
            <TextboxSet
              type="time"
              name="time"
              value={eventInfo.time}
              label="Time"
              onChange={handleOnChange}
              required
            />
          </div>
          <div className="flex w-full gap-[24px]">
            <TextboxSet
              type="textarea"
              name="description"
              value={eventInfo.description}
              label="Event Description"
              onChange={handleOnChange}
            />
          </div>
          <div className="flex flex-col gap-[24px]">
            <div className="flex w-full gap-[16px] items-center">
              <Switch
                checkedIcon={false}
                uncheckedIcon={false}
                offColor="#EFF0F2"
                onColor="#5C4BF5"
                width={48}
                height={28}
                checked={eventInfo.seat_management}
                onChange={() => {
                  setEventInfo({
                    ...eventInfo,
                    seat_management: !eventInfo.seat_management,
                  });
                }}
              />
              <p>Seats Management</p>
            </div>
            <div className="flex w-full gap-[16px] items-center">
              <Switch
                checkedIcon={false}
                uncheckedIcon={false}
                offColor="#EFF0F2"
                onColor="#5C4BF5"
                width={48}
                height={28}
                checked={eventInfo.dietary_management}
                onChange={() => {
                  setEventInfo({
                    ...eventInfo,
                    dietary_management: !eventInfo.dietary_management,
                  });
                }}
              />
              <p>Special Dietray Management</p>
            </div>
          </div>
        </div>
      </SectionCard>

      {/* Event image upload section */}
      <SectionCard title="Event Image">
        <div className="flex flex-col w-full">
          <ImageUpload handleChange={handleImageChange} />
          {eventInfo.image &&
            eventInfo.image.map((image, index) => (
              <div
                key={index}
                className="relative flex flex-col w-full max-h-[200px] bg-black rounded-xl justify-center items-center"
              >
                <div className="absolute left-[20px] top-[8px] flex items-center gap-[18px]">
                  <XMarkIcon
                    className="size-[16px] h-fit text-white hover:cursor-pointer"
                    onClick={() => handleRemoveImage(index)}
                  />
                  <p className="h-fit text-white font-normal">
                    {fileName[index]}
                  </p>
                </div>
                <img
                  src={image}
                  alt="event-image"
                  className="h-[200px] object-contain"
                />
              </div>
            ))}
        </div>
      </SectionCard>

      <Button variant="error" className="w-fit" onClick={toggleModal}>
        Delete Event
      </Button>
    </div>
  );
};

export default EventInformation;
